import { formatDistanceToNow } from 'date-fns';

export const formatDistanceToNowSafe = (
  value: string | number | Date | null | undefined,
  fallback = 'Unknown time'
): string => {
  if (!value) return fallback;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  try {
    return formatDistanceToNow(date, { addSuffix: true });
  } catch {
    return fallback;
  }
};
